import { render } from "./OurAchievements.vue?vue&type=template&id=d5939a34&scoped=true"
import script from "./OurAchievements.vue?vue&type=script&lang=js"
export * from "./OurAchievements.vue?vue&type=script&lang=js"

import "./OurAchievements.vue?vue&type=style&index=0&id=d5939a34&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5939a34"]])

export default __exports__